/**
 * Labstep
 *
 * @module containers/UserSettings
 * @desc Container for user settings
 */

import {
  selectFolderIncludeSubfolders,
  setFolderIncludeSubfoldersActionCreator,
} from 'labstep-web/state/new/user-settings';
import type { LabstepReduxState } from 'labstep-web/state/types';
import type React from 'react';
import { connect } from 'react-redux';
import type {
  WithUserSettingsInjectedProps,
  WithUserSettingsMapDispatchToProps,
  WithUserSettingsMapStateToProps,
} from './types';

interface WithUserSettingsOwnProps {
  folderType: string;
}

const mapStateToProps = (
  state: LabstepReduxState,
  ownProps: WithUserSettingsOwnProps,
): WithUserSettingsMapStateToProps => ({
  folderIncludeSubfolders: selectFolderIncludeSubfolders(
    ownProps.folderType,
  )(state),
});

const mapDispatchToProps: WithUserSettingsMapDispatchToProps = {
  setFolderIncludeSubfolders: setFolderIncludeSubfoldersActionCreator,
};

export const withUserSettings = <
  P extends WithUserSettingsInjectedProps & WithUserSettingsOwnProps,
  S,
>(
  Component: React.FC<P> | React.ComponentClass<P, S>,
): React.FC<
  Pick<P, Exclude<keyof P, keyof WithUserSettingsInjectedProps>>
> => connect(mapStateToProps, mapDispatchToProps)(Component as any);
